var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-box",
    class: {
      'tag-box--easty': _vm.directionIsEasty,
      'tag-box--southy': _vm.directionIsSouthy
    },
    style: _vm.styles,
    attrs: {
      "id": _vm.$attrs._id
    }
  }, [_c('div', {
    staticClass: "tag-box__arrow-col"
  }, [_c('fa', {
    style: _vm.arrowStyle,
    attrs: {
      "icon": 'arrow-up'
    }
  })], 1), _c('div', {
    staticClass: "tag-box__content-col",
    attrs: {
      "dir": _vm.language.dir
    }
  }, [_c('div', {
    staticClass: "tag-box__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label[_vm.language.code])
    }
  }), _c('div', {
    staticClass: "tag-box__distance"
  }, [_c('fa', {
    staticClass: "tag-box__car",
    attrs: {
      "icon": ['fad', _vm.faIcon]
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.distance[_vm.language.code])
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }